import { FieldError } from './FieldError.js';

export function InputField({
  name,
  type = 'text',
  autoComplete,
  placeholder,
  value,
  onChange,
  hasError,
  error,
}) {
  const labelClasses = `flex flex-col p-3 bg-white border rounded-lg ${
    hasError ? 'border-coral-400' : 'border-charcoal-200'
  } focus-within:outline-charcoal-700 focus-within:outline-2 focus-within:outline`;

  return (
    <>
      <label className={labelClasses}>
        <span className="sr-only">{placeholder}</span>
        <input
          type={type}
          name={name}
          autoComplete={autoComplete}
          className="border-0 px-2 py-1 outline-none placeholder-charcoal-900"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
      </label>
      <FieldError error={error} />
    </>
  );
}
